// ── Realm metadata for the 5× overworld expansion ──
//
// Each realm is a contiguous biome region of the overworld map. Realms are
// authored as rectangles (see `TilemapPayload.realmZones`) and resolved at
// runtime to attach a `realmId` to each player. Client + server consume this
// for ambient zone swaps, weather overrides, and dungeon-gate metadata.
//
// Source: docs/design/realms-and-bosses.md §1 "World Overview".
import { DungeonTheme, Difficulty } from '../types/loot.js';
/** Stable identifiers for the four overworld realms. */
export var RealmId;
(function (RealmId) {
    RealmId["VerdanaFields"] = "verdana_fields";
    RealmId["SablewindReaches"] = "sablewind_reaches";
    RealmId["FrostmereExpanse"] = "frostmere_expanse";
    RealmId["EmberMire"] = "ember_mire";
})(RealmId || (RealmId = {}));
export const REALM_METADATA = {
    [RealmId.VerdanaFields]: {
        id: RealmId.VerdanaFields,
        displayName: 'Verdana Fields',
        biome: 'meadow',
        difficulty: Difficulty.Normal,
        dungeonTheme: DungeonTheme.Dungeon,
        ambientZone: 'ambient_verdana',
        descriptor: 'Where the vines forgot to climb',
    },
    [RealmId.SablewindReaches]: {
        id: RealmId.SablewindReaches,
        displayName: 'Sablewind Reaches',
        biome: 'desert',
        difficulty: Difficulty.Hard,
        dungeonTheme: DungeonTheme.Crypt,
        ambientZone: 'ambient_sablewind',
        descriptor: 'Where the winds grew weary and lay down in the sand',
    },
    [RealmId.FrostmereExpanse]: {
        id: RealmId.FrostmereExpanse,
        displayName: 'Frostmere Expanse',
        biome: 'snow',
        difficulty: Difficulty.Nightmare,
        dungeonTheme: DungeonTheme.Crypt,
        ambientZone: 'ambient_frostmere',
        descriptor: 'Where winter forgot how to thaw',
    },
    [RealmId.EmberMire]: {
        id: RealmId.EmberMire,
        displayName: 'Ember Mire',
        biome: 'lava',
        difficulty: Difficulty.Nightmare,
        dungeonTheme: DungeonTheme.Lava,
        ambientZone: 'ambient_ember',
        descriptor: 'Where the fires became ash, and the ash became lonely',
    },
};
/** Type guard — narrow an arbitrary string to a valid RealmId. */
export function isRealmId(value) {
    return (value === RealmId.VerdanaFields ||
        value === RealmId.SablewindReaches ||
        value === RealmId.FrostmereExpanse ||
        value === RealmId.EmberMire);
}
/** Broadcast message: server tells a client which realm its player is now in. */
export const MSG_PLAYER_REALM_CHANGE = 'player_realm_change';
/** Broadcast message: first time a player enters a realm (ceremony trigger). */
export const MSG_REALM_FIRST_VISIT = 'realm_first_visit';
/** Client → server: player pressed E near a waystone. */
export const MSG_WAYSTONE_INTERACT = 'waystone_interact';
/** Server → client: waystone directional info response. */
export const MSG_WAYSTONE_INFO = 'waystone_info';
/** Client -> server: dev-only speed multiplier toggle (AGE-1965). */
export const MSG_DEV_SPEED = 'dev_speed';
//# sourceMappingURL=realms.js.map